module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/costo-envio/costo-envio-list/costo-envio-list.component.scss
// module id = ./src/app/pedido/costo-envio/costo-envio-list/costo-envio-list.component.scss
// module chunks = main